import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

import { initialState } from './slice';

const selectDomain = (state?: RootState) => state?.alert || initialState;

export const selectAlert = createSelector([selectDomain], alertState => alertState);
